
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {AssetId, BlobId, ProjectId, UserId} from "../../types/ids";
import {AuthService} from "../../services/auth.service";
import {isDefined} from "../../utils/utils";
import {GenericApiResponse} from '../apibase.api';
import { HttpClient } from '@angular/common/http';

export type AssetJson = any;

/**
 * REST Access to webmate Asset API.
 */
@Injectable({
  providedIn: "root"
})
export class AssetAndBlobApi {
    constructor (public OAuth2AuthService: AuthService, private http: HttpClient) { }

    getUrlToAssetData(assetId: AssetId): string {
        return this.OAuth2AuthService.makeAuthorizedUrl("/assets/" + assetId + "/data");
    }

    getUrlToBlobData(blobId: BlobId): string {
        return this.OAuth2AuthService.makeAuthorizedUrl("/blobs/" + blobId);
    }

    getAssetSrcDataByName(assetName: string, projectId: ProjectId): string {
        return this.OAuth2AuthService.makeAuthorizedUrl("/projects/" + projectId+ "/assets/"+ assetName + "/data");
    }

    getAssetDataAsJson(assetId: AssetId): Observable<AssetJson> {
        return this.http.get<any>("/assets/" + assetId + "/data");
    }

    downloadAssetAsBlob(assetId: AssetId): Observable<Blob> {
        return this.http.get("/assets/" + assetId + "/data", {
            responseType: 'blob'
        });
    }

    putBlob(blob: Blob, projectId?: ProjectId): Observable<BlobId>{
      if (isDefined(projectId)){
          return this.http.post<any>("/projects/"+projectId+"/blobs", blob);
      } else {
          return this.http.post<any>("/commons/blobs", blob);
      }
    }

    getBlob(blobId: BlobId): Observable<Blob>{
        return this.http.get("/blobs/" + blobId, { responseType: 'blob' });
    }

    createAsset(blobId: BlobId, creator: UserId, assetType: string, projectId?: ProjectId, name?: string, documentType?: string): Observable<AssetId>{
        let request = {
            blobId: blobId,
            creator: creator,
            assetType: assetType,
        };
        if (isDefined(name)){
            request['optName'] = name;
        }
        if (isDefined(projectId)){
            request['projectId'] = projectId;
        }
        if (isDefined(documentType)) {
            request['assetDocumentType'] = documentType;
        }
        return this.http.post<any>("/assets/", request);
    }

    deleteAsset(assetId: AssetId): Observable<GenericApiResponse> {
        return this.http.delete<GenericApiResponse>(`/assets/${assetId}`);
    }
}
